/**
 * Created by Darius on 2016.08.07.
 */
import React, {Component} from 'react';
import {connect} from "react-redux";
import {Paper, CircularProgress } from 'material-ui';
import {lightBlue50} from 'material-ui/styles/colors';


class LinuxStatus extends Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const {linuxRunningStatus, linuxCpuUsage, linuxMemoryUsage} = this.props;

        return (
            <Paper className="dashboard-page" zDepth={1}>
                <div>Linux: <span className="dashboard-status">{linuxRunningStatus}</span></div>

                <div style={{position: "relative"}} className="round-progress">
                    <CircularProgress mode="determinate" value={100} size={100} thickness={5} color={lightBlue50} style={{position: "absolute"}}/>
                    <CircularProgress mode="determinate" value={linuxCpuUsage} size={100} thickness={5} />
                    <div className="progress-text">CPU:<br/>{linuxCpuUsage.toFixed(0)}%</div>
                </div>

                <div style={{position: "relative"}} className="round-progress">
                    <CircularProgress mode="determinate" value={100} size={100} thickness={5} color={lightBlue50} style={{position: "absolute"}}/>
                    <CircularProgress mode="determinate" value={linuxMemoryUsage} size={100} thickness={5}/>
                    <div className="progress-text">MEM:<br/>{linuxMemoryUsage.toFixed(0)}%</div>
                </div>

                <div className="dashboard-summary">
                    <span>&nbsp;</span>
                </div>

            </Paper>
        );
    }
}

const mapStateToProps = state => ({
    linuxRunningStatus: state.dashboard.linuxServerStatus ? state.dashboard.linuxServerStatus.LinuxRunningStatus : 'Offline',
    linuxCpuUsage: state.dashboard.linuxServerStatus ? state.dashboard.linuxServerStatus.LinuxCpuUsage : 0,
    linuxMemoryUsage: state.dashboard.linuxServerStatus ? state.dashboard.linuxServerStatus.LinuxMemoryUsage : 0
});

LinuxStatus = connect(mapStateToProps)(LinuxStatus);

export default LinuxStatus;